import React from 'react';
import Can from "../common/guards/can";

const PageFilter = ({name, children}) => {
  switch (name) {
    case "Privacy Policy": {
      return (
        <Can action="manage" subjectClass="PrivacyPolicy">
          {children}
        </Can>
      )
    }
    default: return children
  }
};

export default PageFilter;


// WEBPACK FOOTER //
// ./src/components/pages/PageFilter.jsx